/**
 * Customer Types
 * @see mobile: module-customer/src/types/front.graphql.ts - CustomerAddress type
 *
 * IMPORTANT: CustomerAddress type should come from front.graphql.ts (GraphQL generated)
 * to match mobile pattern. Do NOT create custom CustomerAddress interface here.
 */

// Re-export everything from front.graphql first
// This includes CustomerAddress, CustomerAddressInput, etc.
export * from './front.graphql';

// Additional types that don't exist in GraphQL schema
export interface AddressInput {
    firstname: string;
    lastname: string;
    company?: string;
    street: string[];
    city: string;
    region?: string;
    region_id?: number;
    postcode?: string;
    country_code: string;
    telephone: string;
    default_shipping?: boolean;
    default_billing?: boolean;
}

export interface AddressFormData {
    firstname: string;
    lastname: string;
    company?: string;
    street1: string;
    street2?: string;
    city: string;
    region?: string;
    region_id?: number;
    postcode?: string;
    country_code: string;
    telephone: string;
    default_shipping?: boolean;
    default_billing?: boolean;
}

export interface Region {
    id: number;
    code: string;
    name: string;
}

export interface District {
    id: number;
    name: string;
    region_code: string;
    region_id: number;
}

export interface Ward {
    id: number;
    name: string;
    district_id: number;
}

export interface Country {
    code: string;
    name: string;
    regions?: Region[];
}

// Address type enum
export enum AddressTypeEnum {
    Home = 'home',
    Office = 'office',
}
